import React from 'react';
import PropTypes from 'prop-types';
import Img from '../../../components/Img';
import styles from './MagicLinkNotification.scss';

const MagicLinkNotification = ({ isOpen, type, title, message, onClose }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className={styles.overlay} onClick={onClose} data-testid="modal.magic-link-notification.overlay">
            <div className={`${styles.popup} ${styles[type]}`} onClick={(e) => e.stopPropagation()}>
                <div className={styles.closeButton} onClick={onClose} data-testid="modal.magic-link-notification.close-btn">
                    <Img src="/img/v4/close-popup-circle.svg" alt="Close" data-testid="modal.magic-link-notification.close-icon" />
                </div>
                <div className={styles.popupContent}>
                    <div className={styles.left}>
                        {type === 'success' && <Img src="/img/v4/circle-check-green.svg" alt="Success" data-testid="modal.magic-link-notification.success-icon" />}
                        {type === 'error' && <Img src="/img/v4/triangle-exclamation-red.svg" alt="Error" data-testid="modal.magic-link-notification.error-icon" />}
                    </div>
                    <div className={styles.container}>
                        {title && <div className={styles.title} data-testid="modal.magic-link-notification.title">{title}</div>}
                        <div className={styles.body} data-testid="modal.magic-link-notification.message">{message}</div>
                    </div>
                </div>
                <div className={styles.buttonsContainer}>
                    <button type="button" className="btn btn-primary" onClick={onClose} data-testid="modal.magic-link-notification.ok-btn">
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

MagicLinkNotification.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['success', 'error']).isRequired,
    title: PropTypes.string,
    message: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
};

MagicLinkNotification.defaultProps = {
    title: '',
};

export default MagicLinkNotification;
